import { render, staticRenderFns } from "./ReviewsCategoriesTable.vue?vue&type=template&id=7cc54134&scoped=true&"
import script from "./ReviewsCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesTable.vue?vue&type=style&index=0&id=7cc54134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc54134",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
